module.exports = __webpack_public_path__ + "f2ff2475c2d156465fa3c19ff0b8a574.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/menu.svg
// module id = +n/P
// module chunks = 0